import React from 'react'
import { Col, HBox, Wrapper } from 'src/ui/layout'
import { styled, useTheme } from 'src/ui/theme'
import { Body, Header } from 'src/ui/typography'
import { WAVES_BIG_TEXT } from './constants'
import { Image } from 'src/ui/atoms'

const Title = styled.div`
  display: grid;

  grid-template-columns: 1fr 1fr;
`

const TitleImages = styled.div`
  display: grid;

  grid-template-columns: 1fr 1fr;
  gap: 50px;

  box-sizing: border-box;
`

export type Props = { images: TImages }

export const Waves = ({ images }: Props) => {
  const theme = useTheme()
  return (
    <Wrapper>
      <Title>
        <Col>
          <Header as="h2" size="h2">
            KODE WAVES
          </Header>
        </Col>
        <Col>
          <Body>{WAVES_BIG_TEXT}</Body>
          <HBox height={24} />
          <Body color={theme.colors.black.secondary}>
            *Признан одной из лучших маркетинговых коммуникаций года по версии
            Tagline.
          </Body>
        </Col>
      </Title>
      <HBox height={64} />
      <TitleImages>
        <Col>
          <Image height={289} fluid={images['waves']} />
        </Col>
        <Col>
          <Image height={289} fluid={images['waves2']} />
        </Col>
      </TitleImages>
    </Wrapper>
  )
}
